<template>
  <div style="margin: 5px;">
    <div class="v-item-label-wrap">
      <span v-if="isRequired" class="v-item-required" :class="{'is-required-single': isRequired}"></span>
      <label v-if="label"
        :class="[
          `v-item-label`,
          // {
          //   'is-required': isRequired
          // }
        ]">
        {{ label }}
        <a-tooltip v-if="tooltip"
                   :title="tooltip"
                   :getPopupContainer='triggerNode => triggerNode.parentNode'
                   placement="top"
                   class="tip-icon">
          <Icon icon="ant-design:question-circle-outlined" />
        </a-tooltip>
      </label>
      <slot name="label"></slot>
    </div>
    <div>
      <slot></slot>
      <p v-if="validateState === 'error' " class="error">{{ validateMessage }}</p>
    </div>
  </div>
</template>
    
<script>
import AsyncValidator from "async-validator";
import { useGlobalProperties } from '/@/hooks/core/useGlobal'
  
export default {
  name: "vFormItem",
  props: {
    label: { type: String, default: '' },
    prop: { type: String, default: '' },
    required: { type: Boolean, default: false},
    rules: { type: Object },
    tooltip: { type: String, default: '' },
  },
  inject: ["eForm"], // 解释一
  created() {
    const { ee } = this.bus
    // this.$on("validate", this.validate);
    ee.on(ee.Event.FormValidate, this.validate)
  },
  mounted() { // 解释二
    if (this.prop) { // 解释三
      // this.dispatch('EForm', 'addField', this);
      const { ee } = this.bus
      ee.emit(ee.Event.AddField, this)
    }
  },
  data() {
    return {
      validateMessage: "",
      validateState: "",
      bus: useGlobalProperties().$bus,
    };
  },
  computed: {
    rule() {
      return this.rules ? this.rules : (!!this.prop && !!this.eForm.rules) ? this.eForm.rules[this.prop] : []
    },
    isRequired() {
      let res = this.required
      let rules = this.rules
      rules?.forEach(it => {
        if (it.required) {
          res = true
        }
      })
      return res
    }
  },
  methods: {
    validate() {
      // 解释四
      return new Promise(resolve => {
        // 解释五
        const descriptor = {
          // name: this.form.rules.name =>
          // name: [ { require: true }, { ... } ]
        };
        descriptor[this.prop] = this.rule
        const validator = new AsyncValidator(descriptor);
        const model = {};
        model[this.prop] = this.eForm.model[this.prop];
        // 异步校验
        validator.validate(model, errors => {
          if (errors) {
          this.validateState = "error";
          this.validateMessage = errors[0].message;
    
          resolve(false);
          } else {
          this.validateState = "";
          this.validateMessage = "";
    
          resolve(true);
          }
        });
      });
    },
    // 查找上级指定名称的组件
    dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root;
      var name = parent.$options.name;
    
      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;
    
        if (parent) {
          name = parent.$options.name;
        }
      }
      if (parent) {
        bus.ee.apply(parent, [eventName].concat(params));
      }
    }
  }
};
</script>
    
<style scoped>
.error {
  color: red;
}
.v-item-label-wrap {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}
.v-item-label{
  margin: 8px 0;
  display: inline-block;
  white-space: pre-wrap;
  word-break: break-all;
}
.v-item-label.is-required:before {
  --el-color-danger:#f56c6c;
  content:"*";
  color:var(--el-color-danger);
  margin-right:4px
}
.v-item-required.is-required-single:before {
  --el-color-danger:#f56c6c;
  content:"*";
  color:var(--el-color-danger);
  margin-right:4px
}
</style>
